import { render, staticRenderFns } from "./info-personal.vue?vue&type=template&id=51a52e0e"
import script from "./info-personal.vue?vue&type=script&lang=js"
export * from "./info-personal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports